var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V45H0V0Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7815 16.2223C29.6926 15.8887 29.5123 15.5334 29.3789 15.2222C27.7824 11.3778 24.2942 10 21.4776 10C17.7072 10 13.5544 12.5334 13 17.7553V18.8222C13 18.8667 13.0153 19.2667 13.0371 19.4668C13.3479 21.9554 15.3076 24.6003 16.7712 27.0889C18.3459 29.7553 19.9798 32.3782 21.5986 35C22.5968 33.2891 23.5913 31.5556 24.5668 29.889C24.8326 29.3998 25.1412 28.911 25.4074 28.4442C25.5847 28.1333 25.9236 27.8225 26.0784 27.5332C27.653 24.6445 30.1875 21.7335 30.1875 18.8667V17.689C30.1876 17.3782 29.8031 16.2893 29.7815 16.2223ZM21.5467 21.5779C20.4383 21.5779 19.2252 21.0226 18.6264 19.489C18.5372 19.2449 18.5444 18.7557 18.5444 18.7108V18.022C18.5444 16.0669 20.201 15.1778 21.6423 15.1778C23.4166 15.1778 24.7888 16.6002 24.7888 18.3781C24.7888 20.156 23.321 21.5779 21.5467 21.5779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/place-icon.e9d6e5f8.svg";
export { ForwardRef as ReactComponent };